export const environment = {
  production: false,
  apiUrl: 'https://api-staging.snappstay.com',
  blobUrl: 'https://snappstaystorage.blob.core.windows.net/media-files/',
  signalR: 'https://api-staging.snappstay.com/notificationHub',
  paymentUrl: 'https://api-staging.snappstay.com/',
  googleAuthProviderId: 'http://1010395337668-ba9vpncd164a0j7khhiitqqbo0deodbb.apps.googleusercontent.com', 
  auth0Domain: 'dev-5cvlld3pfr2rm4ro.us.auth0.com',
  auth0ClientId: 'DzdK4E8NjbhEXUJBiZrl1CIfCo1Tx4BK',
  stripKey: 'pk_test_51MFRKsBBTF7wRIq2Jk65H3EYmbhlB2cPRG2PkgNgll5entnmhf0KWitEnIcddr2pT4EyfE7TMYvgMCn8aRJlb14w007kMnbmJs',

  //socialAuth configurations
  googleClientId: '1010395337668-ba9vpncd164a0j7khhiitqqbo0deodbb.apps.googleusercontent.com',
  appleServiceId: 'com.snappstay.app',
  webUrl: 'https://staging.snappstay.com',
};